export enum ActionNames {
    APPROVE = 'Approve',
    REJECT = 'Reject',
    SAVE = 'Save',
    SUBMIT = 'Submit',
    RECALL = 'Recall'
  }



export enum ServiceName{
  LOOKUPSERVICE = 'LookupService',
  APPRAISALREVIEW = 'AppraisalReviewService',
  INVESTMENTSERVICE = 'InvestmentService',
  TASKMANAGEMENTSERVICE = 'TaskmgmtService',
  DOCUMENTSERVICE = 'DocumentService',
  DATAMANAGEMENTSERVICE = 'DataManagementService',
  loggingservice = 'LoggingService',
  ENTITLEMENTSERVICE = 'EntitlmentService'
}

export const RegionOptions = [
  { label: 'US', value: 'US' },
  { label: 'EMEA', value: 'EMEA' },
  { label: 'APAC', value: 'APAC' }

];

export enum InvestmentTypes {
  INVESTMENTTYPEQUITY = "Equity",
  INVESTMENTTYPEda = "Debt Asset",
  INVESTMENTTYPEDL = "Debt Liability",
}

